const REAL_ESTATE = 'Real Estate';

const BUSINESS_TYPE = {
    REAL_ESTATE
};

export default BUSINESS_TYPE;
